// Datos estáticos para la web de BRILLOX
// Estos datos reemplazan las llamadas al backend

export const services = [
  {
    id: "1",
    name: "Limpieza Integral",
    description: "Limpieza completa de interiores y exteriores con productos premium",
    image: "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/a2vaay2n_image.png",
    icon: "sparkles"
  },
  {
    id: "2",
    name: "Protección Cerámica",
    description: "Recubrimiento cerámico de última generación para protección duradera",
    image: "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/ocb39mke_image.png",
    icon: "shield"
  },
  {
    id: "3",
    name: "Pulido de Faros",
    description: "Restauración y pulido profesional de faros y carrocerías",
    image: "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/di52xjk5_image.png",
    icon: "sun"
  },
  {
    id: "4",
    name: "Limpieza de Motores",
    description: "Desengrase y limpieza profunda del compartimento motor",
    image: "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/romk2dob_image.png",
    icon: "cog"
  },
  {
    id: "5",
    name: "Aplicación PPF",
    description: "Film de protección de pintura contra impactos y arañazos",
    image: "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/1e8edotw_image.png",
    icon: "layers"
  },
  {
    id: "6",
    name: "Tapizado Premium",
    description: "Tapizado de techos, asientos y volantes con materiales de alta calidad",
    image: "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/gegnea7j_image.png",
    icon: "armchair"
  },
  {
    id: "7",
    name: "Tintado de Lunas",
    description: "Láminas de alta calidad con diferentes niveles de oscurecimiento",
    image: "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/b1iid3cv_image.png",
    icon: "square"
  },
  {
    id: "8",
    name: "Servicio de Recogida",
    description: "Recogemos y entregamos tu vehículo donde lo necesites",
    image: "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/ojplbplb_image.png",
    icon: "truck"
  }
];

export const cars = [
  {
    id: "car-1",
    name: "Volkswagen Arteon R-Line",
    description: "Tratamiento completo de protección cerámica y pulido de carrocería",
    thumbnail: "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/id2zk8vv_image.png",
    images: [
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/id2zk8vv_image.png",
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/odpytj7b_image.png",
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/o9m0wzv7_image.png",
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/sc4jugzo_image.png"
    ],
    services_applied: ["Protección Cerámica", "Pulido de Faros", "Limpieza Integral"]
  },
  {
    id: "car-2",
    name: "Mercedes-AMG G63 Brabus 900",
    description: "Detailing completo exterior e interior con acabado negro mate premium",
    thumbnail: "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/se3chpj9_image.png",
    images: [
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/se3chpj9_image.png",
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/kfv18rl5_image.png",
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/4re0q0sa_image.png",
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/56b84bqt_image.png",
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/6hi0yby5_image.png"
    ],
    services_applied: ["Limpieza Integral", "Protección Cerámica", "Limpieza de Motores"]
  },
  {
    id: "car-3",
    name: "Toyota Proace City",
    description: "Limpieza integral y protección de carrocería para vehículo comercial",
    thumbnail: "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/ktsq12i4_image.png",
    images: [
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/ktsq12i4_image.png",
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/d63nc4bc_image.png",
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/9byrezoe_image.png",
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/lomw56qj_image.png"
    ],
    services_applied: ["Limpieza Integral", "Protección Cerámica", "Pulido de Faros"]
  },
  {
    id: "car-4",
    name: "Mercedes-Benz Clase E Coupé",
    description: "Pulido de carrocería y protección cerámica con acabado de espejo",
    thumbnail: "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/8ylzhjh0_image.png",
    images: [
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/8ylzhjh0_image.png",
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/glc2xvo8_image.png",
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/wft8vicb_image.png"
    ],
    services_applied: ["Protección Cerámica", "Pulido de Faros", "Limpieza Integral"]
  },
  {
    id: "car-5",
    name: "Yamaha Tracer 7",
    description: "Limpieza integral y protección de carrocería para moto sport-touring",
    thumbnail: "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/7mpovf62_image.png",
    images: [
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/7mpovf62_image.png",
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/mg6ywa6c_image.png",
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/vhcm830d_image.png",
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/vsved8rg_image.png"
    ],
    services_applied: ["Limpieza Integral", "Protección Cerámica"]
  },
  {
    id: "car-6",
    name: "Audi A6 Avant",
    description: "Detailing completo interior y exterior con protección cerámica premium",
    thumbnail: "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/xcdd20be_image.png",
    images: [
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/xcdd20be_image.png",
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/dkcwvbne_image.png",
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/xsulw5lm_image.png",
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/apkmm3ej_image.png",
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/1m4v0xwi_image.png"
    ],
    services_applied: ["Limpieza Integral", "Protección Cerámica", "Tintado de Lunas"]
  },
  {
    id: "car-7",
    name: "Mercedes-Benz CLA Shooting Brake",
    description: "Detailing premium interior y exterior con acabado impecable",
    thumbnail: "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/dyputh4u_image.png",
    images: [
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/dyputh4u_image.png",
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/4mlsre6q_image.png",
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/8pez97uc_image.png",
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/4j4z50hm_image.png",
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/70kv2jma_image.png"
    ],
    services_applied: ["Limpieza Integral", "Protección Cerámica", "Tintado de Lunas"]
  },
  {
    id: "car-8",
    name: "Yamaha TMAX",
    description: "Limpieza integral y protección cerámica para scooter deportivo premium",
    thumbnail: "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/bqatmcjc_image.png",
    images: [
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/bqatmcjc_image.png",
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/6adziwos_image.png",
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/m1f71ift_image.png"
    ],
    services_applied: ["Limpieza Integral", "Protección Cerámica"]
  },
  {
    id: "car-9",
    name: "Hyundai Bayon",
    description: "Detailing completo interior y exterior con protección cerámica",
    thumbnail: "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/tshvyt9o_image.png",
    images: [
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/tshvyt9o_image.png",
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/ammlcrlm_image.png",
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/77qmhbep_image.png",
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/yq5vhbl7_image.png"
    ],
    services_applied: ["Limpieza Integral", "Protección Cerámica", "Tintado de Lunas"]
  },
  {
    id: "car-10",
    name: "CUPRA Leon Sportstourer",
    description: "Pulido de carrocería y protección cerámica con acabado de espejo",
    thumbnail: "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/nuj0l92t_image.png",
    images: [
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/nuj0l92t_image.png",
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/0qkuaglm_image.png",
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/8kkwz21l_image.png"
    ],
    services_applied: ["Protección Cerámica", "Pulido de Faros", "Limpieza Integral"]
  },
  {
    id: "car-11",
    name: "Mercedes-Benz ML 4MATIC",
    description: "Detailing completo interior y exterior con pulido de carrocería",
    thumbnail: "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/domh2h1o_image.png",
    images: [
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/domh2h1o_image.png",
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/ioefaug1_image.png",
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/882pk7p8_image.png",
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/cvmb1ilz_image.png"
    ],
    services_applied: ["Limpieza Integral", "Protección Cerámica", "Pulido de Faros"]
  },
  {
    id: "car-12",
    name: "Audi A3 Sportback S-Line",
    description: "Detailing premium interior y exterior con protección cerámica",
    thumbnail: "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/ojecwlv7_image.png",
    images: [
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/ojecwlv7_image.png",
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/35w6li7e_image.png",
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/hw0umwhs_image.png",
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/rc09giep_image.png"
    ],
    services_applied: ["Protección Cerámica", "Limpieza Integral", "Tintado de Lunas"]
  },
  {
    id: "car-13",
    name: "Mercedes-Benz Clase A",
    description: "Pulido de carrocería y protección cerámica con acabado de espejo",
    thumbnail: "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/o2p6ou9n_image.png",
    images: [
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/o2p6ou9n_image.png",
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/5qty1k2h_image.png",
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/tpwcuycu_image.png",
      "https://customer-assets.emergentagent.com/job_gallery-services/artifacts/quuozjlr_image.png"
    ],
    services_applied: ["Protección Cerámica", "Pulido de Faros", "Limpieza Integral"]
  }
];

// Información de contacto
export const contactInfo = {
  phone: "680197056",
  phoneFormatted: "+34 680 19 70 56",
  email: "brillox@brilloxcardetail.com",
  whatsapp: "34680197056",
  address: "Pol. Ind. Juan y Antonio, Polígono Cubilete, 18",
  city: "28864 Ajalvir, Madrid"
};
